import React from 'react';
import MultiImageSection from './MultiImageSection';
import * as FiIcons from 'react-icons/fi';

const { FiHeart } = FiIcons;

function NewGratitudeSection({ 
  images, 
  onAddImage, 
  onDeleteImage 
}) {
  return (
    <MultiImageSection
      title="Gratitudine"
      description="Carica fino a 5 immagini per ricordarti i motivi per cui sei grato."
      icon={FiHeart}
      colorClass="rose"
      images={images}
      onAddImage={onAddImage}
      onDeleteImage={onDeleteImage}
      maxImages={5}
    />
  );
}

export default NewGratitudeSection;